export default defineNuxtRouteMiddleware(async (from, to) => {
  if (true) {  
    const { $i18n } = useNuxtApp();
    window.___gcfg = {
      lang: $i18n.locale.value,
    };
  }
});
